import { apiClient } from "./api";
import { isAxiosError } from "axios";
import { UUID } from "crypto";

class GeneralService {
    private basicURL: string;
    private solicitudURL : string;

    constructor() {
        this.basicURL = "/General";
        this.solicitudURL = "/Solicitud";
    }

    async getContactos(){
        const endpoint = `${this.basicURL}/GetContactos`;
        try{
            const response = await apiClient.get(endpoint);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer la lista de contactos";
            }
        }
    }
    
    //nombre:string, tipoMime:string, 
    async getArchivo(guid:UUID){
        const endpoint = `${this.basicURL}/GetArchivo`;
        const body = {
            // nombre: nombre,
            // tipoMime: tipoMime,
            id: guid
        }
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer el archivo";
            }
        }
    }

    async getAlertasActivas(){
        const endpoint = `${this.basicURL}/GetAlertasActivas`;
        try{
            const response = await apiClient.get(endpoint);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer la lista de alertas activas";
            }
        }
    }

    async getExcel(idFacturador: string, fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean, obraSocialId: string, filtroTiposSolicitud:[]){
        const endpoint = `${this.solicitudURL}/GenerarExcel`;
        const body = JSON.stringify({
            idFacturador: idFacturador,
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            estados: estados,
            texto: texto,
            filtroSinTiposDocumentacion: sinDocu,
            obraSocialId: obraSocialId,
            filtroTiposSolicitud: filtroTiposSolicitud
        });
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer el archivo";
            }
        }
    }

    async getExcelDetallado(idFacturador: string, fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean, obraSocialId: string, filtroTiposSolicitud:[]){
        const endpoint = `${this.solicitudURL}/GenerarExcelDetallado`;
        const body = JSON.stringify({
            idFacturador: idFacturador,
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            estados: estados,
            texto: texto,
            filtroSinTiposDocumentacion: sinDocu,
            obraSocialId: obraSocialId,
            filtroTiposSolicitud: filtroTiposSolicitud
        });
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer el archivo";
            }
        }
    }

    async getExcelTotalizado(idFacturador: string, fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean, obraSocialId: string, filtroTiposSolicitud:[]){
        const endpoint = `${this.solicitudURL}/GenerarExcelTotalizado`;
        const body = JSON.stringify({
            idFacturador: idFacturador,
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            estados: estados,
            texto: texto,
            filtroSinTiposDocumentacion: sinDocu,
            obraSocialId: obraSocialId,
            filtroTiposSolicitud: filtroTiposSolicitud
        });
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer el archivo";
            }
        }
    }

    async GetTiposDocumentacion(){
        const endpoint = `${this.basicURL}/GetTiposDocumentacionSolicitudes`;
        try{
            const response = await apiClient.get(endpoint);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer la lista de tipos de documentos";
            }
        }
    }

    async getExcelAuditor(idsFacturadores: string[], idsObrasSociales: string[], fechaDesde: string, fechaHasta: string, estados: string[], texto: string, sinDocu: boolean, filtroTiposSolicitud:[]){
        const endpoint = `${this.solicitudURL}/GenerarExcelDetalladoAuditores`;
        const body = JSON.stringify({
            idsFacturadores: idsFacturadores,
            idsObrasSociales: idsObrasSociales,
            fechaDesde: fechaDesde,
            fechaHasta: fechaHasta,
            estados: estados,
            texto: texto,
            filtroSinTiposDocumentacion: sinDocu,
            filtroTiposSolicitud: filtroTiposSolicitud
        });
        try{
            const response = await apiClient.post(endpoint, body);
            return response;
        } catch (error: unknown) {
            if (error instanceof Error) {
                return error.message;
            } else {
                return "Error desconocido al traer el archivo";
            }
        }
    }
}
export default GeneralService;